module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/hunt_auth_fail.dd5e2398.png";